import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { BehaviorSubject, debounceTime, Subject } from 'rxjs';
import { OutsourcingFormResponseModel, OutsourcingRequestModel, OutsourcingRequestResponseModel, OutsourcingTypeResponseModel } from '../../../models/outsourcing.model';
import { EventViewModel } from '../../../models-views/event.view.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import LoginModel from '../../../models/user.model';
import { AppCommon } from '../../../providers/app-common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cet-outsourcing',
  standalone: false,
  templateUrl: './cet-outsourcing.component.html',
  styleUrl: './cet-outsourcing.component.scss'
})
export class CetOutsourcingComponent {

  loading:boolean = false
  loadingEdit:boolean = false
  loadingMsg:string = 'Creating Outsourcing Request...'
  outsourcingList = [ ];
  outsourcingForm:any = []
  compareQuatationModalRef?: NzModalRef;
  @ViewChild('compareQuatationModalTitle') compareQuatationModalTitle!: TemplateRef<{}>;
  outsourcingRequestResponseModel = new BehaviorSubject<OutsourcingRequestResponseModel>(new OutsourcingRequestResponseModel());
  outsourcingTypeResponseModel = new BehaviorSubject<OutsourcingTypeResponseModel>(new OutsourcingTypeResponseModel());
  outsourcingRequestList: OutsourcingRequestModel[] = [];
  pageIndex = 1;
  pageSize = 10;
  searchValue: string = '';
  searchValue$ = new Subject();
  isVisibleModal: boolean = false;
  form: FormGroup;
  editingData: any;
  loginModel = new BehaviorSubject<LoginModel>(new LoginModel());
  @Input('eventId') eventId: string | null = null;
  outsourcingFormResponseModel = new BehaviorSubject<OutsourcingFormResponseModel>(new OutsourcingFormResponseModel());
  modalRef: NzModalRef | undefined;
  statusList = [
    { "code": "OPEN", "name": "Open" },
    { "code": "SOURCING", "name": "Sourcing" },
    { "code": "COMPLETED", "name": "Completed" }
  ];


  constructor(private modalService: NzModalService, private vm: EventViewModel, private fb: FormBuilder,
    private route: ActivatedRoute
  ) {
    this.loginModel.next(AppCommon.getloggedInObject());
    this.searchValue$.pipe(debounceTime(500)).subscribe(name => {
      this.pageIndex = 1;
      this.getData();
    })
    this.form = this.fb.group({
      outsourcing_type: [null, Validators.required],
      // outsourcing_form: [null, Validators.required],
      status: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    // this.eventId = Number(this.route.snapshot.paramMap.get('id'));
    this.vm.parentCetOutsourcingComponent = this;
    this.vm.subscribeToOutSourcingTypes(this.outsourcingTypeResponseModel);
    this.vm.subscribeToOutsourcingForm(this.outsourcingFormResponseModel)
    this.vm.subscribeToOutSourcingEventRequest(this.outsourcingRequestResponseModel);
    this.vm.getOutSourcingTypes(1, 100);
    // this.vm.getOutSourcingForm(1, 100);
    // this.getData();
    // this.formTypeChange()
  }

  ngAfterViewInit(): void {

  }


  formTypeChange(){
    this.form.get('outsourcing_type')?.valueChanges.subscribe(
      (value) => {
        console.log(value)
        this.vm.getOutSourcingForm(1,100,value)
      }
    )
  }

  getStatusBadge(status: string): string {
    switch (status) {
      case 'Completed': return 'success';
      case 'Open': return 'processing';
      case 'Sourcing': return 'warning';
      default: return 'default';
    }
  }


  handleModalCancel(): void {
    this.isVisibleModal = false;
    this.loadingEdit = false;
    this.form.reset();
  }

  onSubmit() {
    if (this.form.valid) {

      let payload = this.form.value;
      if(this.editingData){
        payload.id = this.editingData.id;
        payload.modified_by = this.loginModel.value.user.id;;
        payload.event = this.eventId;
        console.log(payload)
        this.loadingMsg = 'Updating Outsourcing Request...'
        this.loadingEdit = true;
        this.vm.updateOutSourcingRequest(payload);
      } else{
        payload.created_by = this.loginModel.value.user.id;
        payload.event = this.eventId;
        this.loadingEdit = true;
        this.vm.createOutSourcingRequest(payload);
      }
       
    }
  }

  requestCreated() {
    this.handleModalCancel();
    this.getData();
    this.editingData = null
  }

  getData(): void {
    this.loading = true
    this.vm.getOutSourcingEventRequests(this.searchValue, this.pageIndex, this.pageSize, this.eventId, 'cet-outsourcing');
  }

  dataReceived() {
    this.outsourcingRequestList = this.outsourcingRequestResponseModel.value.results;
    console.log("============================",this.outsourcingRequestList)
    this.loading = false
  }

  outsourcingFormReceived() {
    this.outsourcingForm = this.outsourcingFormResponseModel.value.results;
    this.form.get('outsourcing_form')?.setValue(null);
  }

  copyToClipboard(text: string): void {
    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      // Notify user on success - you can replace with a toast or message
      alert('Copied to clipboard!');
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      alert('Failed to copy to clipboard');
      console.error('Failed to copy!', err);
    });
  }

 

  closeModal(event: MouseEvent): void {
    // Stop event propagation to prevent any parent click handlers from interfering
    event.stopPropagation();
    if (this.compareQuatationModalRef) {
      this.compareQuatationModalRef.destroy(); // Destroy the modal instance
      this.compareQuatationModalRef = undefined; // Clear the reference
    }
  }

 


  onAdd() {
    this.isVisibleModal = true;
  }

  onSearch() {
    this.searchValue$.next(this.searchValue);
  }

  getBase64Image(data: string){
    if(!data){
      return undefined;
    }
    return "data:image/png;base64," + data;
  }

  editRequest(item: any) {
  //  this.handleModalCancel()
   this.isVisibleModal = true;
   this.editingData = item;
   let d = {
    outsourcing_type:item.outsourcing_type_details.id,
    status:item.status
   }
   this.form.patchValue(d)
  }

  deleteRequest(item: any){
    this.vm.deleteOutSourcingRequest(item)
  }

}
